import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class ServiceAdminService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  deleteServiceAdmin(username): Observable<any> {
    const REST_URL = `${this.baseUrl()}/deleteServiceAdmin`;
    return this.http.post(REST_URL, { username });
  }

  getUserListForServiceAdmin(): Observable<any> {
    return this.http.get(`${this.baseUrl()}/getUserListForServiceAdmin`);
  }

  getCountForServiceAdminUsers(): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getCountForServiceAdminUsers`;
    return this.http.get(REST_URL);
  }

  getAdminListForServiceAdmin(): Observable<any> {
    return this.http.get(`${this.baseUrl()}/getAdminListForServiceAdmin`);
  }

  getCountForServiceAdminAdmins(): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getCountForServiceAdminAdmins`;
    return this.http.get(REST_URL);
  }

  updateServiceAdmin(user): Observable<any> {
    const REST_URL = `${this.baseUrl()}/updateServiceAdmin`;
    return this.http.post(REST_URL, {
      email: user.email,
      locked: user.locked || false,
      multipleLogin: user.multipleLogin,
      username: user.username,
      adUsername: user.adUsername,
      deleted: user.deleted,
      isDemoUsers: user.isDemoUsers,
      isWhitelistedEmail: user.isWhitelistedEmail
    });
  }

  registerServiceAdmin(user): Observable<any> {
    const REST_URL = `${this.baseUrl()}/registerServiceAdmin`;
    return this.http.post(REST_URL, user);
  }

  // Temporarily allow for service admin to enter a clear text password
  updateUserPasswordManual(username, newPassword): Observable<any> {
    const REST_URL = `${this.baseUrl()}/updateUserPasswordManual`;
    return this.http.post(REST_URL, {
      username,
      newPassword
    });
  }

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/serviceAdmin`;
  }
}
